import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import './HeaderMenu.css';
import { useNavigate } from 'react-router-dom';

const HeaderMenu = ({ onFilter, isModalOpen, setIsModalOpen }) => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState({ value: 'all', label: 'All' });

    const handleHomeClick = () => {
        setSelectedFilter({ value: 'all', label: 'All' }); // Reset dropdown to "All"
        onFilter(null); // Reset the filter
        navigate('/');
    };

    const handleFilterChange = (selectedOption) => {
        setMenuOpen(false); // Close dropdown after selection
        setSelectedFilter(selectedOption);
        onFilter(selectedOption.value === 'all' ? null : selectedOption.value);
    };

    const filterOptions = [
        { value: 'all', label: 'All' },
        { value: 'trailer', label: 'Trailers' },
        { value: 'film', label: 'Short Films' },
    ];

    const openModal = () => {
        const modalOverlay = document.querySelector('.modal-overlay');
        const modal = document.querySelector('.modal');
    
        if (modalOverlay && modal) {
            // Remove any fade-out class if present
            modalOverlay.style.animation = 'none';
            modal.style.animation = 'none';
    
            // Trigger the fade-in animation
            requestAnimationFrame(() => {
                modalOverlay.style.animation = 'fadeIn 0.3s forwards';
                modal.style.animation = 'fadeIn 0.3s forwards';
            });
        }
    
        setIsModalOpen(true);
    };
    
    const closeModal = () => {
        const modalOverlay = document.querySelector('.modal-overlay');
        const modal = document.querySelector('.modal');

        if (modalOverlay && modal) {
            // Add the fade-out animation class
            modalOverlay.style.animation = 'fadeOut 0.3s forwards';
            modal.style.animation = 'scaleOut 0.3s forwards';

            // Delay unmounting until the animation finishes
            setTimeout(() => {
                setIsModalOpen(false);
            }, 300); // Matches animation duration
        }
    };


    return (
        <>
            <header className="header-menu">
                <div className="left-menu">
                    <button className="logo home-button" onClick={handleHomeClick}>
                        Defect Dreams
                    </button>
                    <nav className="nav-links">
                        <div
                            className="filter-dropdown"
                            onMouseEnter={() => setMenuOpen(true)}
                            onMouseLeave={() => setMenuOpen(false)}
                        >
                            <Select
                                options={filterOptions}
                                onChange={handleFilterChange}
                                value={selectedFilter}
                                menuIsOpen={menuOpen}
                                placeholder=" " // Set an empty placeholder (prevents shadow)
                                isSearchable={false}
                                classNamePrefix="react-select"
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        color: 'transparent', // Make placeholder transparent
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: 'white', // Ensure selected text is visible
                                    }),
                                }}
                            />
                        </div>
                        {/* <a href="#mylist" className="menu-item">
                            My List
                        </a> */}
                        {/* <a href="#comingsoon" className="menu-item">
                            Coming Soon
                        </a> */}
                    </nav>
                </div>
                <div className="right-menu">
                    {/* <button className="menu-item login-button">Login</button> */}
                    <button className="menu-item about-button" onClick={openModal}>
                        About Me
                    </button>
                    <a
                        href="https://www.youtube.com/@DefectDreams/videos?view=0&sort=p&flow=grid"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="right-menu-logo-container"
                    >
                        <img
                            src="/images/About/dog_space_small.png" // Replace with the actual path to your image
                            alt="Site Logo"
                            className="right-menu-logo"
                        />
                    </a>
                </div>

            </header>

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <button className="close-button" onClick={closeModal}>
                            &times;
                        </button>

                        <h2 className="about-heading">About Defect Dreams</h2>
                        <p>
                            Welcome to <strong>Defect Dreams</strong>, a project that merges creativity and technical expertise. Inspired by platforms like Netflix, 
                            this site is an extension of my YouTube channel that I have dedicated a lot to, showcasing trailers and short films aligned with imaginative storytelling.
                        </p>
                        <p>
                            This website demonstrates my ability to design and deploy a dynamic web application using modern development practices, such as:
                        </p>
                        <div className="key-highlights">
                            <ul>
                                <li><strong>Interactive Design:</strong> User-friendly interface inspired by streaming platforms.</li>
                                <li><strong>Technical Excellence:</strong> Built with React and optimized for performance.</li>
                                <li><strong>Scalable Architecture:</strong> Robust backend with API integrations.</li>
                            </ul>
                        </div>
                        <p>
                            I am actively developing a backend component using C# and .NET for user authentication, data management, and secure API endpoints.
                        </p>
                        <p>
                            Thank you for exploring <strong>Defect Dreams</strong>. Let’s create something extraordinary together.
                        </p>

                        <p><strong>David Lee</strong><br />Full-Stack Developer | Content Creator | Innovator</p>
                        <img
                            src="/images/About/space_ape.png"
                            alt="About Defect Dreams"
                            className="modal-image"
                        />
                    </div>
                </div>
            )}

        </>
    );
};

export default HeaderMenu;
